import React from 'react';
import { Typography, Card, List } from 'antd';
import ReactMarkdown from 'react-markdown';
import { AnalysisResult, AnalysisStatus } from '../../../types';
import './markdown.css';

const { Title, Text } = Typography;

interface CommonIssuesProps {
  results: AnalysisResult;
  status: AnalysisStatus;
}

const CommonIssues: React.FC<CommonIssuesProps> = ({ results, status }) => {
  const { common_issues } = results;

  if (status === 'error') {
    return <Text>There was an unexpected error with common issues, once the report is complete, please rerun the analysis.</Text>;
  } else if (status === 'skipped') {
    return <Text>Common issues were skipped by the user.</Text>;
  }

  const issuesData = common_issues?.structured_data?.updated_common_issues;

  if (!issuesData || issuesData.length === 0) {
    // Fallback to markdown content if structured data is not available yet
    const content = common_issues?.message_content || common_issues?.cleaned_content;
    return content ? (
      <div className="markdown-content">
        <ReactMarkdown>{content}</ReactMarkdown>
      </div>
    ) : (
      <Text type="secondary">Analysis in progress...</Text>
    );
  }

  // Sort by likelihood (parsing "85%" to 85)
  const sortedIssues = [...issuesData].sort((a, b) => {
    const likelihoodA = parseInt(a.likelihood?.replace('%', '') || '0', 10);
    const likelihoodB = parseInt(b.likelihood?.replace('%', '') || '0', 10);
    return likelihoodB - likelihoodA;
  });

  return (
    <div>

      <List
        grid={{ gutter: [24, 24], xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}
        dataSource={sortedIssues}
        renderItem={(issue, index) => (
          <List.Item>
            <Card
              title={<Title level={5} style={{ margin: 0, color: '#34495e' }}>{`${index + 1}. ${issue.title}`}</Title>}
              bordered={true}
              style={{ borderRadius: 8, width: '100%', boxShadow: '0 4px 8px rgba(0,0,0,0.08)', display: 'flex', flexDirection: 'column', height: '100%' }}
              headStyle={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid #e9ecef' }}
              bodyStyle={{ flex: 1 }}
            >
              <p><strong> Likelihood:</strong> <Text strong style={{ color: '#e67e22' }}>{issue.likelihood}</Text></p>
              <p><strong>📝 Justification:</strong> {issue.justification}</p>
              <p><strong>🩺 Symptoms:</strong> {issue.symptoms}</p>
              <p><strong>🛠️ Causes:</strong> {issue.causes}</p>
              <p style={{ background: '#f1f2f6', padding: '10px', borderRadius: '4px', marginTop: '12px' }}>
                <strong>Repair Cost:</strong> {issue.repair_cost}
              </p>
            </Card>
          </List.Item>
        )}
      />
    </div>
  );
};

export default CommonIssues;
